module.exports = __webpack_public_path__ + "img/36.dbab02eb.jpg";